import { googleAnalyticsEvent } from 'shared/util/analytics'
import log from 'shared/util/log'

type ActionTypes =
    | 'Share Click'
    | 'Ellipsis Click'
    | 'Link Click'
    | 'Media Click'
    | 'Embed Click'
    | 'Drag To Save'
    | 'Tag Click'
    | 'Image Right Click'
    | 'Related Click'
    | 'Reaction Click'
    | 'Reaction Change'
    | 'Attribution Click'
    | 'Source Click'
    | 'Next Click'
    | 'Previous Click'
    | 'Favorite'
    | 'Related Favorite'
    | 'Download Backdrop'
    | 'Credits Grid Media Click'
    | 'Credits Grid Channel Click'

export const CATEGORY = 'GIF Detail'
export const Actions = {
    shareClick: 'Share Click',
    ellipsisClick: 'Ellipsis Click',
    copyLink: 'Link Click',
    copyMedia: 'Media Click',
    copyEmbed: 'Embed Click',
    drag: 'Drag To Save',
    tag: 'Tag Click',
    rightClick: 'Image Right Click',
    relatedClick: 'Related Click',
    reactionClick: 'Reaction Click',
    reactionChange: 'Reaction Change',
    attributionClick: 'Attribution Click',
    sourceClick: 'Source Click',
    nextClick: 'Next Click',
    previousClick: 'Previous Click',
    favorite: 'Favorite',
    relatedFavorite: 'Related Favorite',
    downloadBackdrop: 'Download Backdrop',
    creditGridMediaClick: 'Credits Grid Media Click',
    creditGridChannelClick: 'Credits Grid Channel Click',
}
export const trackEvent = (action: ActionTypes, label: string) => {
    // to avoid refactoring facebook, reddit, pinterest, twitter use those strings
    action = Actions[action] || action
    log.debug(`${CATEGORY} GA Event - action: ${action}, label: ${label}`)
    googleAnalyticsEvent({
        category: CATEGORY,
        action,
        label,
    })
}
